import PropTypes from "prop-types"
import { capitalize } from "lodash"
import { SEARCHABLE_MENU_ITEM } from "helpers/shapes"
import { getFactorRiskColumns } from "helpers/factor-view"
import AnalyzeFactorsContent from "components/analyze-factors-content"

import "./styles.scss"

export default function IntradayRiskFactors({ selectedFactorCategory, totalRow, factors, categories, setFactorCategory, filtersVisible, currency }) {
  const titlePrefix = `${capitalize(selectedFactorCategory)}${selectedFactorCategory !== "factors" ? " factors" : ""}`

  return <div className="modules_intraday-risk-factors">
    <AnalyzeFactorsContent {...{
      type: "risk",
      titlePrefix,
      totalRow,
      columns: getFactorRiskColumns("table", false, currency),
      totalColumns: getFactorRiskColumns("total", false, currency),
      categoriesColumns: getFactorRiskColumns("categories", false, currency),
      factors,
      categories,
      selectedFactorCategory,
      setFactorCategory,
      filtersVisible,
    }}
    />
  </div>
}

IntradayRiskFactors.propTypes = {
  menuItems: PropTypes.arrayOf(SEARCHABLE_MENU_ITEM).isRequired,
  selectedView: PropTypes.string.isRequired,
  selectedFactorCategory: PropTypes.string.isRequired,
  totalRow: PropTypes.array.isRequired,
  factors: PropTypes.array.isRequired,
  categories: PropTypes.array.isRequired,
  setFactorCategory: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  filtersVisible: PropTypes.bool,
  currency: PropTypes.string,
}
